let children = [];
//------------ CALIDAD -------------------------
// children.push({
//     path: "/Calidad",
//     name: "QA",
//     component: () =>
//         import ("@/views/Quality/RawMaterialSupplier.vue"),
//     meta: {
//         authenticated: true,
//         breadcrumb: [
//             { text: "Inicio", href: "/#/" },
//             // { text: "Producción", disabled: true },
//             { text: "Calidad", href: "/Calidad" },
//         ],
//     },
// });

children.push({
    path: "/Calidad",
    name: "QARMS",
    component: () =>
        import ("@/views/Quality/RawMaterialSupplier.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            // { text: "Producción", disabled: true },
            { text: "Calidad", href: "/Calidad" },
        ],
    },
});

children.push({
    path: "/Quality/MangoTraining",
    name: "QLT_TRAINING",
    component: () =>
        import ("@/views/Quality/MangoTraining.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Calidad", disabled: true },
            { text: "Entrenamiento", href: "/Quality/MangoTraining" },
        ],
    },
});

export { children }